import { UITypes } from "types"

import downloadFile from "utils/downloadFile"

export const exportPackingDevices = (validatedDevices: UITypes.InvalidDevice[], orderId: number) => {
  const validDevices = validatedDevices.filter(item => item.sn && item.sn.trim() !== "")
  const numberOfDevices = validDevices.length
  const headerRow = ["Number", "Device S/N"]
  const dataRows = validDevices.map((item, index) => [index + 1, item.sn])

  const csvContent = [
    `Devices: ${numberOfDevices}`,
    headerRow.map(item => (item?.toString().includes(",") ? `"${item}"` : item)).join(","),
    ...dataRows.map(row =>
      row
        .map(item => (typeof item === "string" ? item.replaceAll('"', '""') : item))
        .map(item => (item?.toString().includes(",") ? `"${item}"` : item))
        .join(","),
    ),
  ].join("\n")

  downloadFile([csvContent], `order-${orderId}-packing-devices.csv`)
}
